import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
    max-width: 620px;
    display: flex;
    flex-wrap: wrap;
    margin: 1em auto 5em;
    justify-content: center;
`

const ContentWrapper = props =>
    <Wrapper className={props.className}>
        {props.children}
    </Wrapper>

ContentWrapper.propTypes = {
    className: PropTypes.string,
    children: PropTypes.object

}

export default ContentWrapper
